import { render, staticRenderFns } from "./MyCompanyBusinessUnitPricingNew.vue?vue&type=template&id=71e63f81&"
import script from "./MyCompanyBusinessUnitPricingNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyBusinessUnitPricingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports